import styled from 'styled-components';

export const Input = styled.input`
  font-family: 'Spectral-Regular', serif;
  width: ${(props) => (props.fullWidth ? '100%' : '120px')};
  padding: 0.75rem;
  border: 1px solid #283618;
  font-size: 0.875rem;
  color: #283618;

  &::placeholder {
    color: #283618;
  }

  &:focus {
    outline: none;
    border-color: #283618;
  }
`;
